import { Types } from "../elements/reactive/types";
import { objectHash } from "../util/hash";

export const createFontFaceStyles = (font: Types["Font"]) => {
  if (font.type !== "custom" || !font.customFont) return null;

  const entries = Object.entries(font.customFont);

  const fontFaces = entries.map(([variant, file]) => {
    if (!file?.path) return null;

    const values = [
      `font-family: '${font.name}';`,
      `src: url('${file.path}');`,
      `font-weight: ${variant.replace(/i$/, "")};`,
      `font-style: ${/i$/.test(variant) ? "italic" : "normal"};`,
      `font-display: swap; `,
      font?.customFontOptions?.["size-adjust"]
        ? `size-adjust: ${Math.floor(
            font.customFontOptions["size-adjust"] * 100
          )}%;`
        : null,
    ].filter((v) => v);

    return `@font-face { ${values.join(" ")} }`;
  });

  const id = objectHash(font);

  return {
    id,
    styles: `${fontFaces.filter((v) => v).join("\n")}`,
  };
};
